let token

export const setToken = (t) => {
  token = t
  localStorage.setItem('token', token)
}

export const isUserLoggedIn = () => {
  return token || localStorage.getItem('token')
}

export const userLogOut = () => {
  localStorage.clear()
}
